import inbox from '~audio/inbox.wav'
import teamChat from '~audio/team-chat.wav'
import actionItem from '~audio/action-item.wav'

export const AUDIO_SOUNDS = {
    teamChat,
    inbox,
    actionItem,
}

export function playAudio(sound: string) {
    const audio = new Audio(sound)
    audio.volume = 0.5
    audio.play()
}
